(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("core-tracking-objects"), require("core-utils"));
	else if(typeof define === 'function' && define.amd)
		define("core-application-tracking", ["core-tracking-objects", "core-utils"], factory);
	else if(typeof exports === 'object')
		exports["core-application-tracking"] = factory(require("core-tracking-objects"), require("core-utils"));
	else
		root["core-application-tracking"] = factory(root["core-tracking-objects"], root["core-utils"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__8286__, __WEBPACK_EXTERNAL_MODULE__8717__) {
return 